export const problemas: string[] = [
  'Domingo a la noche improvisando qué cocinar para el lunes',
  'Heladera vacía a mitad de semana — delivery otra vez',
  'Siempre lo mismo: fideos, arroz blanco, atún con lo que haya',
  'Querés comer sano pero no sabés por dónde empezar',
  'Gastás $20.000 por semana en delivery sin darte cuenta',
  'Llegás agotada del trabajo y no hay nada listo — otra noche de caos',
  'Las viandas al trabajo son siempre las mismas y aburridas',
  'El fin de semana volvés a empezar el mismo ciclo sin fin',
]
